import { render, staticRenderFns } from "./OnlineStatusInput.vue?vue&type=template&id=895bb384&scoped=true&"
import script from "./OnlineStatusInput.vue?vue&type=script&lang=ts&"
export * from "./OnlineStatusInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895bb384",
  null
  
)

export default component.exports